export const RESUME = {
    title: "Resume",
    subtitle: "My",
    typeWriter: ["Education", "Experience"],
    education: [
        {
            year: "2013 - 2014",
            institution: "Nurjahan Aliya Madrsha",
            subject: "SSC",
            description: "I'm passed Secondary School Certificate with G.P.A(4.33).",
        },
        {
            year: "2015 - 2017",
            institution: "Dinajpur Adarsha College",
            subject: "HSC",
            description: "I'm passed  Higher Secondary Certificate with G.P.A(3.67).",
        },
        {
            year: "2022",
            institution: "K.B.M National University",
            subject: "B.B.A (2nd year)",
            description: "I'm student at Zoology."
        }
    ],
    experience: [
        {
            year: "2022 - Present",
            company: "KS Devware",
            role: "Fronted Web Developer",
            description: "I'm join As a junior Fronted Developer at July 2022.",
        },
        {
            year: "2019 - 2022",
            company: "Developer",
            role: "Back-end Developer",
            description: "Adipisicing Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
        },
        // {
        //     year: "2010 - 2015",
        //     company: "Pocotep LLC",
        //     role: "Web Designer",
        //     description: "Adipisicing Lorem ipsum dolor sit amet, consectetur elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        // }
    ],
    skills: [
        {
            name: "Web Design",
            parentage: 95
        },
        {
            name: "React",
            parentage: 80
        },
        {
            name: "Mobile Apps",
            parentage:70
        },
        {
            name: "Graphic Design",
            parentage: 60
        },
        {
            name: "UI/UX Design",
            parentage: 75
        },
        {
            name: "Back-End Development",
            parentage: 40
        },
    ]
}